// removed by extract-text-webpack-plugin
module.exports = {"AssignDropdown":"AssignDropdown---1Nmv0"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/AssignDropdown.styl
// module id = NYrp
// module chunks = 89